export default __webpack_public_path__ + "static/media/product3.c85bb807.png";